import { render, staticRenderFns } from "./CustomConversion.vue?vue&type=template&id=10968670&scoped=true&"
import script from "./CustomConversion.vue?vue&type=script&lang=js&"
export * from "./CustomConversion.vue?vue&type=script&lang=js&"
import style0 from "./CustomConversion.vue?vue&type=style&index=0&id=10968670&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10968670",
  null
  
)

export default component.exports